import React, { useEffect } from "react";
import Right from "../SVG/Right";
import { Text } from "../Text";
import "./Stepper.scss";
import { StepperItem, StepperProps } from "./Stepper.types";

const Stepper = ({ action, stepperList, goTo }: StepperProps) => {
  const [list, setList] = React.useState(stepperList);

  useEffect(() => {
    setList(stepperList);
  }, [stepperList]);

  const getStatusName = (
    status:
      | "started"
      | "not started"
      | "completed"
      | "progress"
      | "delay"
      | "optional"
      | "clickToStart"
      | "skipped"
      | "completed with delay",
    isActive: boolean
  ) => {
    switch (status) {
      case "not started":
        return "Not Started";
      case "completed":
        return "Completed";
      case "progress":
        return "In Progress";
      case "delay":
        return "Completed With Delay";
      case "completed with delay":
        return "Completed With Delay";
      case "clickToStart":
        return (
          <Text type="link" fonts="normal" onTextClick={action}>
            Click Here To Start
          </Text>
        );
      case "skipped":
        return "Skipped";
      default:
        return status;
    }
  };
  const clickHandler = (i: number) => {
    const updatedList = list.map((item: StepperItem, ind: number) => ({
      ...item,
      isActive: i === ind,
    }));
    setList(updatedList);
    goTo(stepperList[i]);
  };
  return (
    <div className="stepper-wrapper">
      {list &&
        list.map(
          (
            { title, step, isActive, status, detail, progress }: StepperItem,
            index: number
          ) => (
            <div
              className="stepper"
              key={title}
              onClick={() => clickHandler(index)}
              aria-hidden="true"
            >
              <div
                className={`stepper-body stepper-body-${
                  status?.toLowerCase() === "completed with delay"
                    ? "delay"
                    : status?.toLowerCase() === "not started"
                    ? "clickToStart"
                    : status
                }${isActive ? " stepper-body-active" : ""}`}
                style={{ height: progress ? 56 : 40 }}
              >
                <div
                  className={`stepper--step stepper--step-${
                    status?.toLowerCase() === "completed with delay"
                      ? "delay"
                      : status?.toLowerCase() === "not started"
                      ? "clickToStart"
                      : status
                  }${isActive ? " stepper--step-active" : ""}`}
                >
                  {status === "completed" ? <Right /> : step}
                </div>
                <div className="stepper--w100">
                  <div className="stepper--container">
                    <div className="stepper--title">
                      {title}
                      {status && (
                        <div className="stepper--detail">
                          {status === "progress"
                            ? "In Progress"
                            : status === "completed"
                            ? "Completed"
                            : status === "skipped"
                            ? "Step Skipped"
                            : status === "not started"
                            ? "Not Started"
                            : status === "delay"
                            ? "Completed with Delay"
                            : status === "started"
                            ? "Started"
                            : status === "clickToStart"
                            ? "Click to Start"
                            : ""}
                        </div>
                      )}
                    </div>
                    <div
                      className={`stepper--status cursor-pointer stepper--status-${
                        status?.toLowerCase() === "completed with delay"
                          ? "delay"
                          : status?.toLowerCase() === "not started"
                          ? "clickToStart"
                          : status
                      }${isActive ? " stepper--status-active" : ""}`}
                    >
                      {getStatusName(status, isActive)}
                    </div>
                  </div>
                  {progress && (
                    <div className="stepper--progress-bar">
                      <div
                        className={`stepper--progress-bar-${
                          status?.toLowerCase() === "completed with delay"
                            ? "delay"
                            : status?.toLowerCase() === "not started"
                            ? "clickToStart"
                            : status
                        }`}
                        style={{ width: `${progress}%` }}
                      />
                    </div>
                  )}
                </div>
                {/* Vertical line after every step*/}
              </div>
              {list.length - 1 !== index && (
                <div
                  className={`stepper--line stepper--line-${
                    status?.toLowerCase() === "completed with delay"
                      ? "delay"
                      : status?.toLowerCase() === "not started"
                      ? "clickToStart"
                      : status
                  }`}
                />
              )}
            </div>
          )
        )}
    </div>
  );
};

export default Stepper;
